import ReactGA from 'react-ga';
import { GA_ID } from '../../../ApiConstants';
import { logEvent } from '../../../services/Analytics';

export const initGA = () => {
  ReactGA.initialize(GA_ID);
};

export const PageView = () => {
  ReactGA.pageview(window.location.pathname + window.location.search);
};

export const Event = logEvent;
